import { effect, EffectRef, EventEmitter, Injector } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { BasemapService } from '@connect-services/client/services/basemap.service';

export class BasemapControl extends AbstractMapControl {
    public basemapToggled: EventEmitter<void> = new EventEmitter<void>();
    private readonly activeEffectRef: EffectRef;
    public constructor(
        map: Map,
        private readonly basemapService: BasemapService,
        private readonly translocoService: TranslocoService,
        injector: Injector,
    ) {
        super(basemapService.button);
        this.map = map;

        this.activeEffectRef = effect(
            () => {
                this.basemapService.isActive();
                this.refreshButton();
            },
            { injector },
        );
    }

    protected initButton(): void {
        this.setupButton('map-background', () => this.toggleMapChoice(), ['basemap-control']);

        this.refreshButton();
    }

    private refreshButton(): void {
        this.basemapService.setButtonIcon();

        this.setButtonState({
            isActive: this.basemapService.isActive(),
        });

        this.setButtonTitle(this.translocoService.translate('basemap'));
    }

    private toggleMapChoice(): void {
        if (!this.map) {
            return;
        }

        this.basemapService.isActive.set(!this.basemapService.isActive());
        this.basemapToggled.emit();

        this.refreshButton();
    }
}
